"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGraphqlParams = getGraphqlParams;
exports.journeyPlannerQuery = journeyPlannerQuery;
exports.nsrQuery = nsrQuery;

var _http = require("./http");

var _config = require("./config");

function minify(query) {
  return query.trim().replace(/\s+/g, ' ');
}

function errorHandler(response) {
  var _response$errors;

  if (response === null || response === void 0 ? void 0 : (_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : _response$errors[0]) {
    throw new Error("GraphQL: ".concat(response.errors[0].message));
  }

  if (!(response === null || response === void 0 ? void 0 : response.data)) {
    throw new Error('Entur SDK: No data available');
  }

  return response.data;
}

function getGraphqlParams(query, variables) {
  return {
    query: minify(query),
    variables: variables
  };
}

function journeyPlannerQuery(queryObj, variables, config) {
  var _getJourneyPlannerHos = (0, _config.getJourneyPlannerHost)(config),
      host = _getJourneyPlannerHos.host,
      headers = _getJourneyPlannerHos.headers;

  var url = "".concat(host, "/graphql");
  var params = getGraphqlParams(queryObj, variables);
  return (0, _http.post)(url, params, headers, undefined, config.fetch).then(errorHandler);
}

function nsrQuery(query, variables, config) {
  var _getNSRHost = (0, _config.getNSRHost)(config),
      host = _getNSRHost.host,
      headers = _getNSRHost.headers;

  var url = "".concat(host, "/graphql");
  var params = {
    query: minify(query),
    variables: variables
  };
  return (0, _http.post)(url, params, headers, undefined, config.fetch).then(errorHandler);
}